import { useContext, useState } from 'react';
import styled from '@emotion/styled';
import FormContext from 'context/ContactForm';
import FormInput from 'components/FormInput';
import FormTextArea from 'components/FormTextArea';
import { RiArrowRightUpLine } from 'react-icons/ri';

const FormInputs = styled.div`
  display: flex;
  flex-direction: column;
`;
const Button = styled.button`
  all: unset;
  user-select: none;
  box-sizing: border-box;
  cursor: pointer;
  ${({ theme }) => theme.mixins.Body};
  color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mixins.flexRowCenter};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  padding: 1rem;
  width: 100%;
  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;

  svg {
    font-size: 1.4em;
    transition: transform 0.3s ease;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.accent};
      border-color: ${({ theme }) => theme.colors.accent};
      color: ${({ theme }) => theme.colors.black};

      svg {
        transform: translateY(-0.2rem);
      }
    }
  }
`;

const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

const Form = () => {
  const { formData, resetFormData } = useContext(FormContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsSent(false);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact-form', ...formData }),
    })
      .then((response) => {
        if (response.ok) {
          resetFormData();
          setIsSent(true); // show "Sent" after success
        } else {
          throw new Error(`HTTP status ${response.status}`);
        }
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
        setIsSent(false);
      })
      .finally(() => {
        setIsSubmitting(false);
        // Optionally reset "Sent" message after 3 seconds
        setTimeout(() => setIsSent(false), 3000);
      });
  };

  const getButtonLabel = () => {
    if (isSubmitting) return 'Sending...';
    if (isSent) return 'Message Sent';
    return 'Send Message';
  };

  return (
    <form
      name="contact-form"
      aria-labelledby="contact-form"
      method="post"
      data-netlify="true"
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="form-name" value="contact-form" />
      <FormInputs>
        <FormInput type="text" name="name" label="Name" required="required" />
        <FormInput
          type="email"
          name="email"
          label="Email"
          required="required"
        />
        <FormInput type="text" name="subject" label="Subject" />
        <FormTextArea
          name="message"
          label="Message"
          maxLength={250}
          required="required"
        />
      </FormInputs>
      <Button type="submit" disabled={isSubmitting}>
        {getButtonLabel()}
        <RiArrowRightUpLine aria-hidden="true" />
      </Button>
    </form>
  );
};

export default Form;
